module.exports = __webpack_public_path__ + "static/media/poisoned.3a57b83b.png";